import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, textBox } from "trader.ts/ui.forms";
import * as style from "../../../styles/style.css.classes";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import { emailValidation } from "../../lib/emailisvalid";
import { mandatoryValidation } from "../../lib/validate";
import * as routes from "../../routes";

export function render(opts: {
  account: null | { email: string };
}): HTMLElement | HTMLElement[] {
  const account = opts.account;

  if (account === null) {
    const form = new Form({})
      .addField("email", [], () =>
        textBox({
          initialVal: "",
          type: "email",
          label: "Email",
          validations: [mandatoryValidation, emailValidation],
        }),
      )
      .build();
    return (
      <div>
        <div>{form.render()}</div>
        <div style="text-align: right">
          {renderSaveButton({
            formS: form.s,
            save: function (acc) {
              return rpc(routes.saveNewAdminAccountSpec, undefined, acc);
            },
            timeout: 1500,
            reload: () =>
              (document.location = routes.adminaccountsRoute.link()),
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <article>
          <label for="">{"Email"}</label>
          <div className={style.input_like}>{account.email}</div>
        </article>
        <div style="text-align: right">
          {renderDeleteButton({
            label: "Verwijder beheerder",
            confirmationLabel: "Ben je zeker dat je deze beheerder wilt verwijderen?",
            doDelete: function () {
              return rpc(routes.deleteAdminAccountSpec, undefined, {
                email: account.email,
              });
            },
            redirectTo: routes.adminaccountsRoute.link(),
          })}
        </div>
      </div>
    );
  }
}
